import React from 'react'

export const Page1English = () => {
  return (
    <div className="page-container">
      <h1>Introduction</h1>
      <p>
        Respectful Greetings, Making the Kumbabhishek flower should be one with
        the Kumbabhishek work. The person who made the flower, those who studied
        the flower, and those who helped materially to make the flower all have
        the benefit of seeing the Kumbabhishek
      </p>
      <p>
        I have prepared this flower that never withers as per the wishes of
        Bangalore devotees who have performed the renovations and the
        Kumbabhishekam at the Kolapadu Sri Ayyanar Sri Adhiyannan temples.
        Generally, there is a mythological history for deities like Vinayagar,
        Shiva, Perumal, Mariamman, and Ayyanar. But this flower is related to
        Sri Adhiyanna Swamy. This flower has been published based on the hearsay
        information I heard from the elders in the village and the scenes I saw
        firsthand. Some of the participants in the renovation have also recorded
        their experiences in this flower.
      </p>
      <p>
        My eternal gratitude and respect to all the dear people who helped me to
        publish this flower, and to the Thiruvarur Ink Graphics Company for
        printing it beautifully.
      </p>
      <p>With love, S. Vasudevan, Retired Editor, Kolapadu</p>
      <h1>Sri Adhiyannan Duthi:</h1>
      <p>
        May the supreme deity who has no beginning and end, who has become a
        blazing light like a torch, and who is present in Medhini with the name
        Adhiyannan, bless us.
      </p>
      <h1>
        Arulmigu Adhiyannan Subordinate
        <br />
        Arulmigu Ayyanar Subordinate
      </h1>
      <h1>History of Kolapadu Village, where both temples are located:</h1>
      <p>
        Kolapadu Village - Located on the Keevalur Kachanam route in
        Thirukuvalai taluk of Nagai district. This holy place is considered
        special because it has four sacred places in the four directions, and
        there are also Sri Akilandeswari Sametha Sundareswarar Temple and many
        other temples in this town.
      </p>
      <p>
        To the north of the village of Kolapadu, where this temple is located,
        there is the Valivalam Sri Manathunai Nadhar Temple, also known as
        Munnuthimangalam, which is a sacred place.
      </p>
    </div>
  )
}
